module.exports = __webpack_public_path__ + "static/img/page_26.ef3447fd.png";